var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"canvas-parent"},[_c('canvas',{ref:"canvas",attrs:{"id":_vm.canvasId,"height":_vm.heightInPixel}})])}
var staticRenderFns = []

export { render, staticRenderFns }